import React, { useState, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';

import axios from 'axios';
import './App.css'; // Assuming you have a CSS file for styling

function App() {
  const [theme, setTheme] = useState('dark');
  const [name, setName] = useState('');
  const [passportNumber, setPassportNumber] = useState('');
  const [ppExpiryDate, setPpExpiryDate] = useState('');
  const [dob, setDob] = useState('');
  const [address, setAddress] = useState('');
  const [workStartDate, setWorkStartDate] = useState('');
  const [workEndDate, setWorkEndDate] = useState('');
  const [country, setCountry] = useState('');
  const [contFisical, setContFisical] = useState('');
  const [nissNum, setNissNum] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (workStartDate) {
      const start = new Date(workStartDate);
      const end = new Date(start);
      end.setMonth(end.getMonth() + 6);
      end.setDate(end.getDate() - 1);
      setWorkEndDate(end.toISOString().split('T')[0]);
      console.log(`Work End Date set to: ${end.toISOString().split('T')[0]}`);
    }
  }, [workStartDate]);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateWorded = (date) => {
    const months = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month} de ${year}`;
  };

  const validateDob = (dob) => {
    const today = new Date();
    const dobDate = new Date(dob);
    return dobDate <= today;
  };

  const validatePassportNumber = (passportNumber) => {
    const regex = /^[A-Za-z0-9]{6,12}$/;
    return regex.test(passportNumber);
  };

  const validateFiscalNISS = (number) => {
    const regex = /^[0-9]{6,11}$/;
    return regex.test(number);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    if (!name || !passportNumber || !ppExpiryDate || !dob || !address || !workStartDate || !country || !contFisical || !nissNum) {
      setErrorMessage('Please fill all the fields.');
      setLoading(false);
      return;
    }

    if (!validateDob(dob)) {
      setErrorMessage('Date of Birth cannot be in the future.');
      setLoading(false);
      return;
    }

    if (!validatePassportNumber(passportNumber)) {
      setErrorMessage('Passport Number should be 10 characters long.');
      setLoading(false);
      return;
    }

    if (!validateFiscalNISS(contFisical)) {
      setErrorMessage('Fiscal Number should be 11 digits long.');
      setLoading(false);
      return;
    }

    if (!validateFiscalNISS(nissNum)) {
      setErrorMessage('NISS Number should be 11 digits long.');
      setLoading(false);
      return;
    }
    const start = new Date(workStartDate);
    const end = new Date(start);
    end.setMonth(end.getMonth() + 6);
    end.setDate(end.getDate() - 1);
    const formattedStartDate = formatDate(start);
    const formattedDOB = formatDate(new Date(dob));
    const wordedStartDate = formatDateWorded(start);
    const formattedEndDate = formatDate(end);
    const formattedPPExpiryDate = formatDate(new Date(ppExpiryDate));
    console.log('submitting data:', {
      name,
      passportNumber,
      formattedPPExpiryDate,
      formattedDOB,
      address,
      formattedStartDate,
      formattedEndDate,
      country,
      contFisical,
      nissNum,
      wordedStartDate
    });
    try {
      const response = await axios.post('https://salakaprisma-backend.onrender.com/generate_contract', {
        name:name,
        passport_number: passportNumber,
        pp_expiry_date: formattedPPExpiryDate,
        dob: formattedDOB,
        address: address,
        work_start_date: formattedStartDate,
        work_end_date: formattedEndDate,
        country: country,
        cont_fisical: contFisical,
        niss_num: nissNum,
        worded_date: wordedStartDate
      }, { responseType: 'blob' });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name+' work contract.docx');
      document.body.appendChild(link);
      link.click();
      link.remove();

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error generating the contract:', error);
    }
  };

  return (
    <div className={`app-container ${theme}`}>
      <div className="theme-toggle">
        <button
          className={`theme-button ${theme === 'dark' ? 'active' : ''}`}
          onClick={() => setTheme('dark')}
        >
          <i className="bi bi-moon"></i> Dark
        </button>
        <button
          className={`theme-button ${theme === 'light' ? 'active' : ''}`}
          onClick={() => setTheme('light')}
        >
          <i className="bi bi-brightness-high"></i> Light
        </button>
      </div>
      <div className="container">
        <h2 className="title">Simple Document Generator</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <form onSubmit={handleSubmit} className="form">
          
          <div className="form-group-1">
            <label className="label">Name</label>
            <div className="form-group">
              <input type="text" className="input" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <label className="label">Passport Number</label>
            <div className="form-group">
              <input type="text" className="input" placeholder="Passport Number" value={passportNumber} onChange={(e) => setPassportNumber(e.target.value)} />
            </div>
            <label className="label">Address</label>
            <div className="form-group">
              <input type="text" className="input" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Country</label>
              <input type="text" className="input" placeholder="Country" value={country} onChange={(e) => setCountry(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Contribuente Fiscal</label>
              <input type="text" className="input" placeholder="Cont Fisical" value={contFisical} onChange={(e) => setContFisical(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">NISS Number</label>
              <input type="text" className="input" placeholder="NISS Number" value={nissNum} onChange={(e) => setNissNum(e.target.value)} />
            </div>

          </div>
          
          <div className="form-group-2">
            <label className="label">Passport Expiry Date</label>
            <div className="form-group">
              <input type="date" className="input" value={ppExpiryDate} onChange={(e) => setPpExpiryDate(e.target.value)} />
            </div>
            <label className="label">Date of Birth</label>
            <div className="form-group">
              <input type="date" className="input" value={dob} onChange={(e) => setDob(e.target.value)} />
            </div>
            
            <div className="form-group">
              <label className="label">Work Start Date</label>
              <input type="date" className="input" value={workStartDate} onChange={(e) => setWorkStartDate(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Work End Date</label>
              <input type="date" className="input" value={workEndDate} onChange={(e) => setWorkEndDate(e.target.value)} />
            </div>

          </div>
          
        </form>
        <div className="button-wrapper">
          <button
            type="submit"
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Generate Contract'}
          </button>

        </div>
        

        
      </div>
    </div>
    

  );
}

export default App;
